import { product, productGroup, cart, discountMessage } from "./fragments";

export const productWithGroup = `
query productWithGroup($id: ID!, $buyer: BuyerInput) @inContext(country: ${window.Shopify.country}, buyer: $buyer) {
  product(id: $id) {
    ${product}
    ${productGroup}
  }
}
`;

// Body copy only. Deliberately not productWithGroup, which drags the whole
// group and 250 variants along for a single-variant swatch product.
export const swatchDetails = `
query swatchDetails($id: ID!) @inContext(country: ${window.Shopify.country}) {
  product(id: $id) {
    id
    title
    descriptionHtml
    variants(first: 1) {
      nodes {
        materialGroup: metafield(namespace: "configurability", key: "material_group") {
          value
        }
        materialDetails: metafield(namespace: "content", key: "material_details") {
          reference {
            ... on Metaobject {
              details: field(key: "details") {
                type
                value
              }
              careInstructions: field(key: "care_instructions") {
                type
                value
              }
            }
          }
        }
      }
    }
  }
}
`;

export const storefrontCartAdditionalData = `
  query storefrontCart($id: ID!) {
    globalDiscountMessages: metaobjects(first: 10, type: "global_discount_message") {
      nodes {
        handle
      }
    }
    cart(id: $id) {
      id
      lines(first: 100) {
        nodes {
          id
          quantity
          merchandise {
            ... on ProductVariant {
              title
              discountMessages: metafield(namespace: "custom", key: "discount_messages") {
                references(first: 15) {
                  nodes {
                    ${discountMessage}
                  }
                }
              }
            }
          }
          discountAllocations {
            ... on CartAutomaticDiscountAllocation {
              title
              discountedAmount {
                currencyCode
                amount
              }
            }
            ... on CartCodeDiscountAllocation {
              title: code
              discountedAmount {
                currencyCode
                amount
              }
            }
          }
        }
      }
    }
  }
`;

export const cartDeliveryAddressesAdd = `
  mutation CartDeliveryAddressesAdd($id: ID!, $addresses: [CartSelectableAddressInput!]!) {
    cartDeliveryAddressesAdd(cartId: $id, addresses: $addresses) {
      userErrors {
        message
        code
        field
      }
      warnings {
        message
        code
        target
      }
      cart {
        ${cart}
      }
    }
  }
`;

export const storefrontCart = `
  query storefrontCart($id: ID!) {
    cart(id: $id) {
      ${cart}
    }
  }
`;

export const cartWithDeliveryGroups = `
  query cartWithDeliveryGroups($id: ID!) {
    cart(id: $id) {
      ${cart}
      ... DeliveryGroups @defer
    }
  }

  fragment DeliveryGroups on Cart {
    deliveryGroups(first: 10, withCarrierRates: true) {
      edges {
        node {
          id
          deliveryOptions {
            title
            handle
            estimatedCost {
              amount
              currencyCode
            }
          }
          selectedDeliveryOption {
            title
            handle
            estimatedCost {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`;

export const cartDeliveryAddressesUpdate = `
mutation CartDeliveryAddressesUpdate($id: ID!, $addresses: [CartSelectableAddressUpdateInput!]!) {
  cartDeliveryAddressesUpdate(cartId: $id, addresses: $addresses) {
    userErrors {
      message
      code
      field
    }
    warnings {
      message
      code
      target
    }
    cart {
      ${cart}
    }
  }
}
`;
